import axios from "axios";

export enum SearchType {
  ENCOUNTER = "ENCOUNTER",
  FLAME = "FLAME",
  CONTACT = "CONTACT",
  EMAIL = "EMAIL",
  CONTACT_ATTACHMENT = "CONTACT_ATTACHMENT",
  PROJECT = "PROJECT",
}
export interface OmniSearch {
  searchType: SearchType;
  upstreamRef: string;
  title: string;
}

interface OmniSearchApi {
  search(searchTerm: string): Promise<OmniSearch[]>;
}

export const omniSearchApi: OmniSearchApi = {
  async search(searchTerm) {
    return (await axios.get(`/api/omnisearch?searchTerm=${searchTerm}`)).data;
  },
};
